import compose from 'compose-function'
import { withRouter } from './with-router'
import { withStore } from './with-store'
import { withToast } from './with-toast'

const withProviders = compose(withStore, withToast, withRouter)

export default withProviders
